import { render, staticRenderFns } from "./dynamicMsg.vue?vue&type=template&id=f4768de4&scoped=true"
import script from "./dynamicMsg.vue?vue&type=script&lang=js"
export * from "./dynamicMsg.vue?vue&type=script&lang=js"
import style0 from "./dynamicMsg.vue?vue&type=style&index=0&id=f4768de4&prod&lang=scss"
import style1 from "./dynamicMsg.vue?vue&type=style&index=1&id=f4768de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4768de4",
  null
  
)

export default component.exports